import { integrationLinksList } from "@/app/Settings/Settings/GraphQL/integrationLinksQueries";
import { deleteIntegrationLink } from "@/app/Settings/Settings/GraphQL/integrationLinkMutations";
import { IntegrationRecord } from "@/app/Settings/Settings/GraphQL/integrationQueries";
import {
  useGqlMutation,
  useSuspenseGqlQuery,
} from "@/lib/GraphQLCodegen/fetcher";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { useSettingsSupplier } from "@/app/Suppliers/Utils/useSettingsSupplier";
import { Button } from "@/components/catalyst/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import { Click4WheelsLinkDialog } from "@/app/Settings/Integrations/Click4Wheels/Click4WheelsLinkDialog";
import { click4WheelsStations } from "@/app/Settings/Integrations/Click4Wheels/click4WheelsStations";

function stationLabel(code: string) {
  const station = click4WheelsStations.find((item) => item.code === code);
  return station ? `${station.name} (${code})` : code;
}

export function Click4WheelsStationLinks({
  integration,
}: {
  integration: IntegrationRecord;
}) {
  const { supplier } = useSettingsSupplier();
  const { open } = useDialog(Click4WheelsLinkDialog);
  const { mutateAsync: deleteLink } = useGqlMutation(deleteIntegrationLink);
  const { data } = useSuspenseGqlQuery(integrationLinksList, {
    integration_id: integration.id,
  });
  const officeLinks = data.integrationLinks.data.flatMap((link) =>
    link.object.__typename === "SupplierOffice"
      ? [{ ...link, office: link.object }]
      : [],
  );

  return (
    <div className="space-y-4">
      <Button
        outline
        onClick={() =>
          open({ integrationId: integration.id, supplierId: supplier.id })
        }
      >
        <PlusIcon />
        Link office
      </Button>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Office</TableHead>
            <TableHead>Click4Wheels station</TableHead>
            <TableHead />
          </TableRow>
        </TableHeader>
        <TableBody>
          {officeLinks.length === 0 ? (
            <TableRow>
              <TableCell colSpan={3} className="text-gray-500">
                No offices linked yet
              </TableCell>
            </TableRow>
          ) : (
            officeLinks.map((link) => (
              <TableRow key={link.id}>
                <TableCell>{link.office.name}</TableCell>
                <TableCell>{stationLabel(link.external_id)}</TableCell>
                <TableCell className="text-right">
                  <Button plain onClick={() => deleteLink({ id: link.id })}>
                    <TrashIcon />
                  </Button>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
